import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import { getStudentDisplayName } from 'approot/students/logic/get-student-display-name';
import { isRichtextValueEmpty } from 'approot/activity-builder/components/shared/logic/get-richtext-value';
import {
  Student,
  StudentProfile,
} from 'approot/activity-builder/classroom/classroom.constants';
import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';

export type StudentFillInBlanksResponse = StudentProfile & {
  answers: AnswerFragment[] | null;
  componentId: string;
};

export function getStudentFillInBlanksAnswers({
  studentsInClass,
  studentAnswers,
  componentId,
}: {
  studentsInClass: Student[];
  studentAnswers: AnswerFragment[];
  componentId: string;
}): StudentFillInBlanksResponse[] {
  const groupedAnswers = groupBy(studentAnswers, 'studentId');

  const studentResponses = studentsInClass.map(student => {
    const allAnswers = groupedAnswers[student.id] || [];

    return {
      studentId: student.id,
      studentName: getStudentDisplayName(student),
      studentEmoji: student.emeji,
      answers: allAnswers,
      componentId,
    };
  });

  const sortedStudentResponses = sortBy(studentResponses, response =>
    response.studentName.toLowerCase()
  );

  const studentsWithAnswers = sortedStudentResponses.filter(student =>
    hasStudentResponseAnswer(student)
  );

  const studentsWithoutAnswers = sortedStudentResponses.filter(
    student => !hasStudentResponseAnswer(student)
  );

  return [...studentsWithAnswers, ...studentsWithoutAnswers];
}

export function hasStudentResponseAnswer(
  response: StudentFillInBlanksResponse
): boolean {
  return (
    response?.answers?.some(a => !isRichtextValueEmpty(getRichtextAnswer(a))) ||
    false
  );
}
